import { toPersianDigits } from '@bookora/shared';
import { JalaliDate, Numeric } from '@bookora/ui';

import { OFFER_COPY } from './copy';
import { useDeadline } from './use-deadline';

const TWO_DAYS_MS = 48 * 3_600_000;
const pad = (n: number) => String(n).padStart(2, '0');

export function OfferCountdown({ expiresAt }: { expiresAt: string | null }) {
  const { msLeft } = useDeadline(expiresAt);
  if (!expiresAt || msLeft === null) return null;
  if (msLeft > TWO_DAYS_MS) {
    return (
      <span>
        {OFFER_COPY.until} <JalaliDate value={expiresAt} withRelative={false} />
      </span>
    );
  }
  const s = Math.floor(msLeft / 1000);
  const clock = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
  return (
    <span role="timer" aria-live="off">
      <Numeric>{toPersianDigits(clock)}</Numeric> {OFFER_COPY.timeLeft}
    </span>
  );
}
